import { CanLoad } from '@angular/router';
import { AppStorage } from '../services/appStorage.service';
import { Route } from '@angular/compiler/src/core';

export class CanLoadPerfil implements CanLoad {
  constructor(private appStorage: AppStorage) {}

  canLoad(route: Route) {
    return true;
  }
}
